import React from "react";
import Input from '@material-ui/core/Input';
import { withStyles } from "@material-ui/core/styles";
import Clear from '@material-ui/icons/CancelOutlined';
import MaskedInput from 'react-text-mask';

const styles = theme =>({
    inputStyle:{
        backgroundColor: theme.ComponentHeader,
        color: theme.TextColor,
        fontSize: theme.textFontSize,
        height: 24,
        boxSizing: "border-box",
        border:`1px solid ${theme.iconColor}`,
        borderRadius:2,
        marginTop:6,
        '&::before, &::after, & input':{
            border:"none !important"
        },
        '& input[type="text"]':{
            color: `${theme.TextColor} !important `,
            padding:5
        },
        '& input$input$maskedInput[type="text"]::placeholder':{
            color:"inherit"
        }
    },
    iconHidden:{
        visibility: "hidden"
    },
    iconVisible:{
        visibility: "visible",
        color: theme.iconColor,
        cursor: "pointer"
    },
    input:{
    },
    maskedInput:{

    }

})

const CustomTextInput = (props) => {
    const { inputRef, ...other } = props;
      return (
      <MaskedInput
        {...other}
        ref={ref => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={props.mask}
        placeholderChar={" "}
        pipe={(value) => value ? value.trim() : value}
        guide={false}
      />
    );
  }

const StyledTextInput = props => {
    const { classes } = props;
    const inputComponent = props.mask ? { inputComponent: CustomTextInput} :{}
    return (
        <Input
            autoFocus
            inputRef={props.inputRef}
            classes={{
                root: classes.inputStyle,
                input:`${classes.input} ${classes.maskedInput}`
            }}
            inputProps={{
                value: props.value,
                placeholder: props.placeholder,
                mask: props.mask,
            }}
            onChange={props.onChange}
            endAdornment={
                <Clear
                    classes={{
                        root: props.value ? classes.iconVisible : classes.iconHidden
                    }}
                    onClick={()=> props.onChange()}
                    display={props.value ? "none" : "block"}
                />}
                {...inputComponent}
        >
        </Input>
    )
}
export default withStyles(styles)(StyledTextInput);
